// @flow

import React from 'react';

import { T } from '@app/components/translation';

type Props = {
  auditLogEvent: AuditLogEvent,
};

const WorkspaceUpdateEvent = ({ auditLogEvent }: Props) => (
  <T
    _str="The workspace {workspace} was updated"
    _comment="Audit log event message for updated workspace"
    workspace={auditLogEvent.target.name}
  />
);

export default WorkspaceUpdateEvent;
